import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../Shared/Buttons/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function SelectMenuPage(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div>
      <div className="page-container page-container--narrow">
        <div className={classes.linkContainer}>
           <div className={classes.boxStyle}>
            <p className={classes.menuItem}>{t('selectMenu.createProjectDescription')}</p>
            <Button
              onClick={() => {
                navigate("/create", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              {t('nav.createProject')}
            </Button>
          </div>
          <div className={classes.boxStyle}>
            <p className={classes.menuItem}>{t('selectMenu.projectOverviewDescription')}</p>
            <Button
              onClick={() => {
                navigate("/projectreportoverview", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              {t('nav.projectOverview')}
            </Button>
          </div>
          <div className={classes.boxStyle}>
            <p className={classes.menuItem}>{t('selectMenu.graphsOverviewDescription')}</p>
            <Button
              onClick={() => {
                navigate("/graphs", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              {t('nav.graphsOverview')}
            </Button>
          </div>
          <div className={classes.boxStyle}>
            <p className={classes.menuItem}>{t('selectMenu.dataManagementDescription')}</p>
            <Button
              onClick={() => {
                navigate("/datamanagement", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              {t('nav.dataManagement')}
            </Button>
          </div>
          <div className={classes.boxStyle}>
            <p className={classes.menuItem}>{t('selectMenu.financialCenterDescription')}</p>
            <Button
              onClick={() => {
                navigate("/financialcenter", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              {t('nav.financialCenter')}
            </Button>
          </div>
          {/* <div className={classes.boxStyle}>
              <p className={classes.menuItem}>View an overview of all revenue and costs linked to your accounts</p>
              <Button className={classes.linkButton} variant="contained" onClick={() => { navigate('/generalledgeraccount', { state: { from: '/' } }) }}>General ledger account</Button>
          </div> */}
          <div className={classes.boxStyle}>
            <p className={classes.menuItem}>{t('nav.configuration')}</p>
            <Button
              onClick={() => {
                navigate("/configuration", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              {t('nav.configuration')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectMenuPage;

const useStyles = makeStyles((theme) => ({
  linkContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "160px",
  },
  boxStyle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#FFFFFF",
    border: "1px solid var(--color-border-light)",
    borderRadius: "8px",

    padding: "16px",
    paddingLeft: "24px",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  menuItem: {
    color: "#1D3557",
    margin: "0",

    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      width: "100% !important",
      marginBottom: "15px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "100% !important",
      fontSize: "1.2rem",
    },
  },
  linkButton: {
    minWidth: "200px",
  },
}));